import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/store/types';
import { IProjectListState } from '@/store/interfaces';

export const state: IProjectListState = {
  projectList: [],
};

const namespaced = true;

export const projectList: Module<IProjectListState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
